import { Link } from 'react-router-dom';
import { breakingNews } from '@/mocks/articles';

export default function HeroSection() {
  const mainArticle = breakingNews[0];

  return (
    <section className="relative w-full min-h-screen flex items-end pb-16 md:pb-24">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={mainArticle.imageUrl}
          alt={mainArticle.title}
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-background-50/20"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/80 via-background-50/30 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-4 md:mb-6">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30">
              <i className="ri-flashlight-fill text-primary-500 text-xs"></i>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap font-label">BREAKING</span>
            </span>
            <span className="text-xs text-foreground-400 font-label">
              {new Date(mainArticle.publishedAt).toLocaleDateString('zh-CN', {
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 font-heading leading-tight mb-4 md:mb-6 tracking-tight">
            <Link to={`/article/${mainArticle.slug}`} className="hover:text-primary-400 transition-colors cursor-pointer">
              {mainArticle.title}
            </Link>
          </h1>

          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 md:mb-8 max-w-xl line-clamp-3">
            {mainArticle.excerpt}
          </p>

          <div className="flex flex-wrap items-center gap-4">
            <Link
              to={`/article/${mainArticle.slug}`}
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-all duration-200 cursor-pointer"
            >
              阅读全文
              <i className="ri-arrow-right-line text-base"></i>
            </Link>

            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line"></i>
                {(mainArticle.views / 10000).toFixed(1)}万阅读
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-chat-3-line"></i>
                {mainArticle.comments}评论
              </span>
            </div>
          </div>

          {breakingNews.length > 1 && (
            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3">
              {breakingNews.slice(1).map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="flex-1 group p-3 md:p-4 rounded-lg bg-background-100/60 backdrop-blur-sm border border-background-200/30 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
                >
                  <div className="flex items-start gap-2.5">
                    <span className="mt-0.5 w-2 h-2 rounded-full bg-primary-500 flex-shrink-0"></span>
                    <div>
                      <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-2 leading-snug">
                        {article.title}
                      </p>
                      <p className="text-xs text-foreground-500 mt-1">
                        {new Date(article.publishedAt).toLocaleDateString('zh-CN', {
                          month: 'short',
                          day: 'numeric',
                        })}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}